import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-delete-customer-dialog',
  templateUrl: './delete-customer-dialog.component.html',
  styleUrls: ['./delete-customer-dialog.component.css']
})
export class DeleteCustomerDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: number,
     
      private customerService: CustomerService) { }

  ngOnInit() {
    console.log(this.data);
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onDeleteConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.customerService.deleteCustomer(this.data)
    .subscribe(
      data => {
        this.api_success = 'Customer deleted Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
       this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }

}
